//@ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SubmitLeadRequest {
  phoneCallId?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  selectedProductTypes?: SelectedProductType[]
  newLeadName?: string
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  /** @format int32 */
  preName?: number
}

export interface SelectedProductType {
  id?: string
  name?: string
  isNew?: boolean
  requestedQuantity?: string
}

export interface SelectedCustomer {
  type?: string
  id?: string
}

export interface SubmitSourceRequest {
  phoneCallId?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  selectedProductTypes?: SelectedProductType[]
  newLeadName?: string
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  /** @format int32 */
  preName?: number
  isOverload?: boolean
  isCooperationRequest?: boolean
}

export interface SubmitTransferRequest {
  phoneCallId?: string
  transferredBusinessUnit?: string
  newLeadName?: string
  isNewCustomer?: boolean
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  /** @format int32 */
  preName?: number
}

export interface SubmitCriticismRequest {
  phoneCallId?: string
  isNewCustomer?: boolean
  description?: string
  newLeadName?: string
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  /** @format int32 */
  preName?: number
}

export interface SubmitOthersRequest {
  phoneCallId?: string
  type?: string
  isNewCustomer?: boolean
  description?: string
  newLeadName?: string
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  /** @format int32 */
  preName?: number
}

export interface RangeDateRequest {
  fromDate?: string
  toDate?: string
}

export interface InputCallsManagementRequest {
  search?: string
  fromDate?: string
  toDate?: string
  types?: number[]
  answered?: boolean
  teamIds?: string[]
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
}

export interface GetInputCallsManagementResponse {
  id?: string
  name?: string
  expertName?: string
  expertId?: string
  phoneNumber?: string
  /** @format date-time */
  date?: string
  /** @format int32 */
  typeValue?: number
  type?: string
  status?: string
  duration?: string
  imageUrl?: string
  voiceUrl?: string
  transferType?: string
  isCallPickup?: boolean
  isLostInIvrOrQueue?: boolean
}

export interface ExpertsListRequest {
  search?: string
  purchaseExpert?: boolean
  salesExpert?: boolean
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
}

export interface GetExpertsListResponse {
  name?: string
  teamName?: string
  position?: string
  positionLevel?: string
  /** @format int32 */
  callCount?: number
}

export interface GetPhoneCallDetailResponse {
  customerDetail?: CustomerDetail
  phoneCallDetail?: PhoneCallDetail
}

export interface CustomerDetail {
  accountName?: string
  accountId?: string
  contactName?: string
  contactId?: string
  leadName?: string
  leadId?: string
  phoneNumber?: string
  /** @format int32 */
  invoiceCount?: number
  /** @format int32 */
  quoteCount?: number
  /** @format int32 */
  callCount?: number
}

export interface PhoneCallDetail {
  id?: string
  /** @format date-time */
  date?: string
  type?: string
  duration?: string
  voiceUrl?: string
  status?: string
  ringDetails?: RingDetail[]
}

export interface RingDetail {
  expertName?: string
  expertPosition?: string
  expertTeam?: string
  status?: string
  imageUrl?: string
  transferType?: string
  isCallPickup?: boolean
  opportunityProductTypes?: OpportunityProductTypeDetail[]
}

export interface OpportunityProductTypeDetail {
  productName?: string
  unit?: string
  quantity?: string
}

export interface GetDailyCallsReportResponse {
  /** @format int32 */
  callCount?: number
  date?: string
}

export interface GetTeamInputCallsReportRequest {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  teamId?: string
  fromDate?: string
  toDate?: string
}

export interface GetTeamInputCallsReportResponse {
  /** @format int32 */
  inputCallsCount?: number
  /** @format double */
  inputCallsProgress?: number
  /** @format int32 */
  answeredCallsCount?: number
  /** @format double */
  answeredCallsProgress?: number
  /** @format int32 */
  notAnsweredCallsCount?: number
  /** @format double */
  notAnsweredCallsProgress?: number
  /** @format int32 */
  pendingCallsCount?: number
  /** @format double */
  pendingCallsProgress?: number
  /** @format int32 */
  pendingTime?: number
  /** @format double */
  pendingTimeProgress?: number
  details?: GetTeamInputCallsReportDetailsResponse[]
}

export interface GetTeamInputCallsReportDetailsResponse {
  /** @format date-time */
  dateTime?: string
  timeString?: string
  /** @format int32 */
  timeInt?: number
  date?: string
  answered?: boolean
  /** @format int32 */
  totalMeanCalls?: number
  /** @format int32 */
  notAnsweredMeanCalls?: number
}

export interface GetTeamMembersInputCallsReportResponse {
  fullName?: string
  imageUrl?: string
  /** @format double */
  percentageProgress?: number
  /** @format double */
  inputCallPercentageRatio?: number
  /** @format double */
  averageCallDuration?: number
  /** @format int32 */
  inputCallCount?: number
  /** @format int32 */
  missedCallCount?: number
  /** @format int32 */
  deadLockCount?: number
  /** @format int32 */
  leadCount?: number
  /** @format int32 */
  unregisteredCallCount?: number
}

export interface GetTransferCallsStatesFromCallCenter {
  callCenterMembers?: GetCallCenterMemberInputCall[]
  getTransferFromCallCenterMembers?: GetTransferFromCallCenter[]
}

export interface GetCallCenterMemberInputCall {
  fullName?: string
  /** @format int32 */
  answeredCallCount?: number
}

export interface GetTransferFromCallCenter {
  fullName?: string
  /** @format int32 */
  fromCallCenterCallCount?: number
  /** @format int32 */
  answeredCallCount?: number
}

export interface StatesAndCities {
  state?: string
  city?: string
}

export interface SearchInCustomersResponse {
  accounts?: FindByNameResponse[]
  contacts?: FindByFullNameResponse[]
  leads?: FindByFullNameAndCompanyNameResponse[]
}

export interface FindByNameResponse {
  id?: string
  name?: string
}

export interface FindByFullNameResponse {
  id?: string
  name?: string
  accountId?: string
  accountName?: string
}

export interface FindByFullNameAndCompanyNameResponse {
  id?: string
  name?: string
  companyName?: string
}

export interface GetCustomerData {
  id?: string
  type?: string
}

export interface GetCallerInfoResponse {
  accountName?: string
  contactName?: string
  leadName?: string
  leadSource?: OptionSetResponse
  accountId?: string
  contactId?: string
  leadId?: string
  preName?: LeadPreName
  /** @format int32 */
  invoiceCount?: number
  isVIP?: boolean
  vipBroker?: string
  companyName?: string
  isNewCustomer?: boolean
  phoneNumber?: string
  phoneNumbers?: string[]
  /** @format int32 */
  quoteCount?: number
  /** @format double */
  accountBalance?: number
  /** @format double */
  creditBalance?: number
  isPrePaymentRequired?: boolean
}

export interface OptionSetResponse {
  label?: string
  /** @format int32 */
  value?: number
}

export interface LeadPreName {
  label?: string
  /** @format int32 */
  value?: number
}

export interface CustomersHappyCallListRequest {
  /** @format int32 */
  order?: number
  openInvoicesCount?: number[]
  assigneeIds?: string[]
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
  search?: string
  fromDate?: string
  toDate?: string
}

export interface GetLostCustomersHappyCallsResponse {
  id?: string
  /** @format date-time */
  createdOn?: string
  customerName?: string
  coordinatorName?: string
  /** @format int32 */
  customerEtc?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  customerId?: string
  opportunityId?: string
  assigneeName?: string
  assigneeImageUrl?: string
  assigneeDomain?: string
  assigneeId?: string
  /** @format int32 */
  phoneCount?: number
  phoneBooks?: PhoneBookResponse[]
  /** @format int32 */
  pendingInvoicesCount?: number
}

export interface PhoneBookResponse {
  isDefault?: boolean
  phoneNumber?: string
  name?: string
  type?: string
}

export interface FindOtherOpportunityHappyCallsRequest {
  opportunityId?: string
  /** @format int32 */
  order?: number
  status?: number[]
  openInvoicesCount?: number[]
  assigneeIds?: string[]
  search?: string
  fromDate?: string
  toDate?: string
}

export interface GetInvoiceCustomersHappyCallResponse {
  id?: string
  invoiceId?: string
  /** @format date-time */
  createdOn?: string
  customerName?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  customerId?: string
  /** @format int32 */
  customerType?: number
  coordinatorName?: string
  description?: string
  /** @format int32 */
  descriptionValue?: number
  /** @format int32 */
  pendingInvoicesCount?: number
  assigneeName?: string
  assigneeImageUrl?: string
  assigneeDomain?: string
  assigneeId?: string
  /** @format int32 */
  phoneCount?: number
  phoneBooks?: PhoneBookResponse[]
}

export interface FindOtherInvoiceHappyCallsRequest {
  invoiceId?: string
  /** @format int32 */
  order?: number
  status?: number[]
  openInvoicesCount?: number[]
  assigneeIds?: string[]
  search?: string
  fromDate?: string
  toDate?: string
}

export interface PurchaseHappyCallResponse {
  id?: string
  purchaseId?: string
  /** @format date-time */
  createdOn?: string
  accountId?: string
  contactId?: string
  customerName?: string
  /** @format int32 */
  purchaseCount?: number
  assigneeName?: string
  assigneeImageUrl?: string
  assigneeDomain?: string
  assigneeId?: string
  /** @format int32 */
  phoneCount?: number
  phoneBooks?: PhoneBookResponse[]
}

export interface FindOtherPurchaseHappyCallsRequest {
  purchaseId?: string
  /** @format int32 */
  order?: number
  status?: number[]
  openInvoicesCount?: number[]
  assigneeIds?: string[]
  search?: string
  fromDate?: string
  toDate?: string
}

export interface HappyCallAssigneeUsersResponse {
  id?: string
  name?: string
}

export interface UpdateHappyCallAssigneeToCurrentUserRequest {
  customerId?: string
}

export interface GetPendingHappyCallsPaginationRequest {
  fromDate?: string
  toDate?: string
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
}

export interface GetChangeRequestHappyCallResponse {
  entityName?: string
  accountName?: string
  contactName?: string
  statusReason?: string
  /** @format int32 */
  statusReasonCode?: number
  change?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  happyCallId?: string
  /** @format date-time */
  createdOn?: string
  result?: string
  createdBy?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  changeRequestId?: string
  subject?: string
  phoneBooks?: PhoneBookResponse[]
}

export interface SubmitAwaitingReviewHappyCallRequest {
  happyCallIds?: string[]
  /** @format int32 */
  happyCallResultOption?: number
}

export interface GetAwaitingReviewHappyCallsRequest {
  /** @format int32 */
  order?: number
  openInvoicesCount?: number[]
  assigneeIds?: string[]
  search?: string
  fromDate?: string
  toDate?: string
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
}

export interface GetAwaitingReviewHappyCallsResponse {
  id?: string
  happyCallId?: string
  /** @format date-time */
  createdOn?: string
  title?: string
  customerName?: string
  customerId?: string
  phoneNumbers?: PhoneBookResponse[]
  requesterName?: string
  requesterImageUrl?: string
  lastHappyCallResult?: string
}

export interface GetOtherCustomerAwaitingReviewHappyCallsRequest {
  fromDate?: string
  toDate?: string
  customerId?: string
}

export interface GetHappyCallInvoicesByCustomerIdRequest {
  customerId?: string
  fromDate?: string
  toDate?: string
}

export interface IdNameResponse {
  id?: string
  name?: string
}

export interface GetHappyCallTypesResponse {
  value?: string
  name?: string
}

export interface GetHappyCallInvoiceIdsRequest {
  invoiceIds?: string[]
}

export interface GetDistinctOnTeamsResponse {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  teamId?: string
  teamName?: string
}

export interface GetDistinctOnUserResponse {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  userId?: string
  name?: string
}

export interface GetDistinctOnProductResponse {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  productId?: string
  productName?: string
}

export interface SubmitInvoiceHappyCallRequest {
  invoiceIds?: string[]
  callDate?: string
  description?: string
  invoiceResultValue?: string
  callReceiverName?: string
  /** @format int32 */
  happyCallResultOption?: number
  /** @format int32 */
  combinatoryDissatisfactionOption?: number
  users?: CombinatoryItems[]
  products?: CombinatoryItems[]
  teams?: CombinatoryItems[]
}

export interface CombinatoryItems {
  id?: string
  /** @format int32 */
  happyCallResultOption?: number
  invoiceResultValue?: string
}

export interface SubmitHappyCallResponse {
  happyCallId?: string
}

export interface GetHappyCallOpportunitiesByCustomerIdRequest {
  customerId?: string
  fromDate?: string
  toDate?: string
}

export interface SubmitOpportunityHappyCallRequest {
  opportunityIds?: string[]
  callDate?: string
  callReceiverName?: string
  description?: string
  opportunityResultValue?: string
}

export interface GetHappyCallPurchasesByCustomerIdRequest {
  customerId?: string
  fromDate?: string
  toDate?: string
}

export interface SubmitPurchaseHappyCallRequest {
  purchaseIds?: string[]
  callDate?: string
  description?: string
  callReceiverName?: string
  purchaseResultValue?: string
  /** @format int32 */
  happyCallResultOption?: number
}

export interface HappyCallReportResponse {
  /** @format double */
  percentageProgress?: number
  /** @format int32 */
  currentCount?: number
}

export interface PaginationRequestWithRangeDateAndSearch {
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
  search?: string
  fromDate?: string
  toDate?: string
}

export interface HappyCallListResponse {
  Id?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  happyCallId?: string
  happyCallName?: string
  account?: string
  contact?: string
  /** @format date-time */
  createdOn?: string
  description?: string
  result?: string
  /** @format int32 */
  resultNumber?: number
  followUp?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  createdById?: string
}

export interface OpportunityHappyCallReportResponse {
  /** @format int32 */
  allHappyCallCount?: number
  /** @format int32 */
  opportunityHappyCallCount?: number
  groupedOpportunitiesByCallResult?: CountType[]
}

export interface CountType {
  name?: string
  /** @format int32 */
  count?: number
}

export interface InvoicesHappyCallStatisticResponse {
  overview?: Overview
  statusCounts?: StatusCount[]
}

export interface Overview {
  /** @format int32 */
  count?: number
  /** @format double */
  percentageProgress?: number
}

export interface StatusCount {
  title?: string
  /** @format int32 */
  count?: number
}

export interface EditLeadNameRequest {
  name?: string
  leadId?: string
  /** @format int32 */
  preName?: number
}

export interface GetOnlineQuotesRequest {
  /** @format int32 */
  status?: number
  /** @format int32 */
  pageSize?: number
  /** @format int32 */
  currentPage?: number
  search?: string
  fromDate?: string
  toDate?: string
}

export interface GetOnlineQuotesResponse {
  id?: string
  opportunityId?: string
  customerName?: string
  customerId?: string
  /** @format int32 */
  customerType?: number
  phoneNumber?: string
  type?: string
  /** @format int32 */
  status?: number
  /** @format date-time */
  createdOn?: string
  fileUrl?: string
  description?: string
}

export interface UpdateOnlineQuoteStatusRequest {
  id?: string
  /** @format int32 */
  value?: number
}

export interface CreatePhoneCallRequest {
  linkedId?: string
  lastAction?: string
  phoneNumber?: string
  parentPhoneCallId?: string
  voiceUrl?: string
}

export interface CreateAttendedTransferPhoneCallRequest {
  linkedId?: string
  lastAction?: string
  phoneNumber?: string
  to?: string
  parentPhoneCallId?: string
  voiceUrl?: string
}

export interface UpdatePhoneCallOnPickup {
  id?: string
  lastAction?: string
  to?: string
  isCallPickup?: boolean
}

export interface UpdatePhoneCallOnVarSet {
  id?: string
  voiceUrl?: string
  lastAction?: string
}

export interface UpdatePhoneCallDateRequest {
  id?: string
}

export interface CreateRingRequest {
  userId?: string
  PhoneCallId?: string
  IsAnswered?: boolean
  /** @format int32 */
  duration?: number
}

export interface UpdateRingRequest {
  ringId?: string
  IsAnswered?: boolean
}

export interface GetProductsByProductTypeRequest {
  productTypeId?: string
  search?: string
  bestselling?: boolean
  mostExpensive?: boolean
}

export interface GetProductsByProductTypeResponse {
  id?: string
  name?: string
  /** @format double */
  price?: number
  unit?: string
  unitId?: string
  size?: string
  standard?: string
  brand?: string
  stock?: string
  state?: string
  /** @format double */
  unitWeight?: number
}

export interface GetProductTypesResponse {
  id?: string
  name?: string
  team?: string
}

export interface GetCurrentUserProductTypesResponse {
  id?: string
  name?: string
}

export interface SubmitPriceInquiryRequest {
  phoneCallId?: string
  opportunityId?: string
  newLeadName?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  /** @format int32 */
  preName?: number
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  companyName?: string
  phoneNumber?: string[]
  companyPhone?: string[]
  description?: string
  isQuoteRequested?: boolean
  cityOfEvacuation?: string
  products?: PriceInquiryRequestProduct[]
}

export interface PriceInquiryRequestProduct {
  productId?: string
  unitId?: string
  /** @format int32 */
  quantity?: number
  /** @format double */
  pricePerUnit?: number
}

export interface SubmitPriceInquiryResponse {
  opportunityId?: string
  opportunityName?: string
}

export interface SubmitSalesPersonTransferRequest {
  phoneCallId?: string
  newLeadName?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  /** @format int32 */
  preName?: number
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  companyName?: string
  phoneNumber?: string[]
  companyPhone?: string[]
  transferredBusinessUnit?: string
}

export interface SubmitSalesPersonOthersRequest {
  phoneCallId?: string
  newLeadName?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  /** @format int32 */
  preName?: number
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  companyName?: string
  phoneNumber?: string[]
  companyPhone?: string[]
  subject?: string
  description?: string
}

export interface SubmitSalesPersonFollowUpRequest {
  phoneCallId?: string
  newLeadName?: string
  /** @format int32 */
  leadSource?: number
  isNewCustomer?: boolean
  /** @format int32 */
  preName?: number
  selectedCustomer?: SelectedCustomer
  requesterUsername?: string
  companyName?: string
  phoneNumber?: string[]
  companyPhone?: string[]
  notes?: SubmittedNote[]
}

export interface SubmittedNote {
  entityName?: string
  entityId?: string
  description?: string
}

export interface GetSystemUsersResponse {
  id?: string
  fullname?: string
  userPhone?: string
  imageUrl?: string
  teamName?: string
  teamId?: string
  userPosition?: string
  userPositionLevel?: string
  userMainProductType?: string[]
  userSubProductType?: string[]
  userDomain?: string
}

export interface GetUsersInfoResponse {
  userInfoId?: string
  userId?: string
  /** @format double */
  transferRate?: number
}

export interface SystemUserTransferRate {
  systemUserId?: string
  /** @format double */
  transferRate?: number
}

export interface FindLastSystemUserTalkedToCustomerResponse {
  id?: string
  fullname?: string
  teamId?: string
  teamName?: string
  userDomain?: string
  userPosition?: string
  imageUrl?: string
}

export interface GetTeamsResponse {
  id?: string
  name?: string
}

export interface BaseRingsModel {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  RingId?: string
  UserName?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  UserId?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  TeamId?: string
  IsAnswered?: boolean
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  PhoneCallId?: string
  /** @format date-time */
  CreatedOn?: string
  TeamName?: string
}

export interface PaginationResponseGetInputCallsManagementResponse {
  items?: GetInputCallsManagementResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetExpertsListResponse {
  items?: GetExpertsListResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetLostCustomersHappyCallsResponse {
  items?: GetLostCustomersHappyCallsResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetInvoiceCustomersHappyCallResponse {
  items?: GetInvoiceCustomersHappyCallResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponsePurchaseHappyCallResponse {
  items?: PurchaseHappyCallResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetChangeRequestHappyCallResponse {
  items?: GetChangeRequestHappyCallResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetAwaitingReviewHappyCallsResponse {
  items?: GetAwaitingReviewHappyCallsResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseHappyCallListResponse {
  items?: HappyCallListResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

export interface PaginationResponseGetOnlineQuotesResponse {
  items?: GetOnlineQuotesResponse[]
  moreRecords?: boolean
  /** @format int32 */
  totalCount?: number
  /** @format int32 */
  currentPage?: number
  /** @format int32 */
  pageSize?: number
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://callcenter-api.ahanoffline.ir:9190',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title Callcenter Crm Api
 * @version v1
 * @baseUrl https://callcenter-api.ahanoffline.ir:9190
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  callcenterForm = {
    /**
     * No description
     *
     * @tags CallcenterForm
     * @name CallcenterFormSubmitLead
     * @request POST:/CallcenterForm/SubmitLead
     */
    callcenterFormSubmitLead: (body: SubmitLeadRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/CallcenterForm/SubmitLead`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterForm
     * @name CallcenterFormSubmitSource
     * @request POST:/CallcenterForm/SubmitSource
     */
    callcenterFormSubmitSource: (body: SubmitSourceRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/CallcenterForm/SubmitSource`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterForm
     * @name CallcenterFormSubmitTransfer
     * @request POST:/CallcenterForm/SubmitTransfer
     */
    callcenterFormSubmitTransfer: (body: SubmitTransferRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/CallcenterForm/SubmitTransfer`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterForm
     * @name CallcenterFormSubmitCriticism
     * @request POST:/CallcenterForm/SubmitCriticism
     */
    callcenterFormSubmitCriticism: (body: SubmitCriticismRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/CallcenterForm/SubmitCriticism`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterForm
     * @name CallcenterFormSubmitOthers
     * @request POST:/CallcenterForm/SubmitOthers
     */
    callcenterFormSubmitOthers: (body: SubmitOthersRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/CallcenterForm/SubmitOthers`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  }
  callcenterReport = {
    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTotalCallcenterCallsCount
     * @request POST:/CallcenterReport/GetTotalCallcenterCallsCount
     */
    callcenterReportGetTotalCallcenterCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetTotalCallcenterCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTotalCallsCount
     * @request POST:/CallcenterReport/GetTotalCallsCount
     */
    callcenterReportGetTotalCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetTotalCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTotalCallcenterMissCallsCount
     * @request POST:/CallcenterReport/GetTotalCallcenterMissCallsCount
     */
    callcenterReportGetTotalCallcenterMissCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetTotalCallcenterMissCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTotalMissCallsCount
     * @request POST:/CallcenterReport/GetTotalMissCallsCount
     */
    callcenterReportGetTotalMissCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetTotalMissCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetUniqueCallsCount
     * @request POST:/CallcenterReport/GetUniqueCallsCount
     */
    callcenterReportGetUniqueCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetUniqueCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetCallcenterUniqueCallsCount
     * @request POST:/CallcenterReport/GetCallcenterUniqueCallsCount
     */
    callcenterReportGetCallcenterUniqueCallsCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetCallcenterUniqueCallsCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetLeadSourceStatistics
     * @request POST:/CallcenterReport/GetLeadSourceStatistics
     */
    callcenterReportGetLeadSourceStatistics: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<Record<string, number>, any>({
        path: `/CallcenterReport/GetLeadSourceStatistics`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetCallsPercentByType
     * @request POST:/CallcenterReport/GetCallsPercentByType
     */
    callcenterReportGetCallsPercentByType: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<Record<string, number>, any>({
        path: `/CallcenterReport/GetCallsPercentByType`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetInputCallsManagement
     * @request POST:/CallcenterReport/GetInputCallsManagement
     */
    callcenterReportGetInputCallsManagement: (body: InputCallsManagementRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetInputCallsManagementResponse, any>({
        path: `/CallcenterReport/GetInputCallsManagement`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportFindRelatedRings
     * @request POST:/CallcenterReport/FindRelatedRings
     */
    callcenterReportFindRelatedRings: (
      query: {
        phoneCallId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetInputCallsManagementResponse[], any>({
        path: `/CallcenterReport/FindRelatedRings`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetExpertsList
     * @request POST:/CallcenterReport/GetExpertsList
     */
    callcenterReportGetExpertsList: (body: ExpertsListRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetExpertsListResponse, any>({
        path: `/CallcenterReport/GetExpertsList`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetNewCustomerCount
     * @request POST:/CallcenterReport/GetNewCustomerCount
     */
    callcenterReportGetNewCustomerCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetNewCustomerCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetCallcenterNewCustomerCount
     * @request POST:/CallcenterReport/GetCallcenterNewCustomerCount
     */
    callcenterReportGetCallcenterNewCustomerCount: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<number, any>({
        path: `/CallcenterReport/GetCallcenterNewCustomerCount`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetPhoneCallDetails
     * @request POST:/CallcenterReport/GetPhoneCallDetails
     */
    callcenterReportGetPhoneCallDetails: (
      query: {
        phoneCallId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetPhoneCallDetailResponse, any>({
        path: `/CallcenterReport/GetPhoneCallDetails`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetDailyCallsReport
     * @request POST:/CallcenterReport/GetDailyCallsReport
     */
    callcenterReportGetDailyCallsReport: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<GetDailyCallsReportResponse[], any>({
        path: `/CallcenterReport/GetDailyCallsReport`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTeamsCallReport
     * @request POST:/CallcenterReport/GetTeamsCallReport
     */
    callcenterReportGetTeamsCallReport: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/CallcenterReport/GetTeamsCallReport`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTeamInputCallsReport
     * @request POST:/CallcenterReport/GetTeamInputCallsReport
     */
    callcenterReportGetTeamInputCallsReport: (body: GetTeamInputCallsReportRequest, params: RequestParams = {}) =>
      this.request<GetTeamInputCallsReportResponse, any>({
        path: `/CallcenterReport/GetTeamInputCallsReport`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTeamMembersInputCallsReport
     * @request POST:/CallcenterReport/GetTeamMembersInputCallsReport
     */
    callcenterReportGetTeamMembersInputCallsReport: (
      body: GetTeamInputCallsReportRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetTeamMembersInputCallsReportResponse[], any>({
        path: `/CallcenterReport/GetTeamMembersInputCallsReport`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetCallcenterExcelReportTest
     * @request POST:/CallcenterReport/GetCallcenterExcelReport
     */
    callcenterReportGetCallcenterExcelReportTest: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/CallcenterReport/GetCallcenterExcelReport`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CallcenterReport
     * @name CallcenterReportGetTransferCallsStatesFromCallCenter
     * @request POST:/CallcenterReport/GetTransferCallsStatesFromCallCenter
     */
    callcenterReportGetTransferCallsStatesFromCallCenter: (
      body: GetTeamInputCallsReportRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetTransferCallsStatesFromCallCenter, any>({
        path: `/CallcenterReport/GetTransferCallsStatesFromCallCenter`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  common = {
    /**
     * No description
     *
     * @tags Common
     * @name CommonGetStatesAndCities
     * @request POST:/Common/GetStatesAndCities
     */
    commonGetStatesAndCities: (
      query: {
        search: string
      },
      params: RequestParams = {}
    ) =>
      this.request<StatesAndCities[], any>({
        path: `/Common/GetStatesAndCities`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  customer = {
    /**
     * No description
     *
     * @tags Customers
     * @name CustomersSearchInCustomers
     * @request POST:/Customer/SearchInCustomers
     */
    customersSearchInCustomers: (
      query: {
        name: string
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchInCustomersResponse, any>({
        path: `/Customer/SearchInCustomers`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name CustomersGetCustomerData
     * @request POST:/Customer/GetCustomerData
     */
    customersGetCustomerData: (data: GetCustomerData, params: RequestParams = {}) =>
      this.request<GetCallerInfoResponse, any>({
        path: `/Customer/GetCustomerData`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  happyCall = {
    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetOpportunityCustomers
     * @request POST:/HappyCall/GetOpportunityCustomers
     */
    happyCallGetOpportunityCustomers: (body: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetLostCustomersHappyCallsResponse, any>({
        path: `/HappyCall/GetOpportunityCustomers`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallFindOtherOpportunityHappyCalls
     * @request POST:/HappyCall/FindOtherOpportunityHappyCalls
     */
    happyCallFindOtherOpportunityHappyCalls: (
      body: FindOtherOpportunityHappyCallsRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetLostCustomersHappyCallsResponse[], any>({
        path: `/HappyCall/FindOtherOpportunityHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetInvoiceCustomers
     * @request POST:/HappyCall/GetInvoiceCustomers
     */
    happyCallGetInvoiceCustomers: (body: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetInvoiceCustomersHappyCallResponse, any>({
        path: `/HappyCall/GetInvoiceCustomers`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallFindOtherInvoiceHappyCalls
     * @request POST:/HappyCall/FindOtherInvoiceHappyCalls
     */
    happyCallFindOtherInvoiceHappyCalls: (body: FindOtherInvoiceHappyCallsRequest, params: RequestParams = {}) =>
      this.request<GetInvoiceCustomersHappyCallResponse[], any>({
        path: `/HappyCall/FindOtherInvoiceHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetPurchaseHappyCalls
     * @request POST:/HappyCall/GetPurchaseHappyCalls
     */
    happyCallGetPurchaseHappyCalls: (body: CustomersHappyCallListRequest, params: RequestParams = {}) =>
      this.request<PaginationResponsePurchaseHappyCallResponse, any>({
        path: `/HappyCall/GetPurchaseHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallFindOtherPurchaseHappyCalls
     * @request POST:/HappyCall/FindOtherPurchaseHappyCalls
     */
    happyCallFindOtherPurchaseHappyCalls: (body: FindOtherPurchaseHappyCallsRequest, params: RequestParams = {}) =>
      this.request<PurchaseHappyCallResponse[], any>({
        path: `/HappyCall/FindOtherPurchaseHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetHappyCallAssigneeUsers
     * @request POST:/HappyCall/GetHappyCallAssigneeUsers
     */
    happyCallGetHappyCallAssigneeUsers: (params: RequestParams = {}) =>
      this.request<HappyCallAssigneeUsersResponse[], any>({
        path: `/HappyCall/GetHappyCallAssigneeUsers`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallUpdateHappyCallAssignee
     * @request POST:/HappyCall/UpdateHappyCallAssigneeToCurrentUser
     */
    happyCallUpdateHappyCallAssignee: (body: UpdateHappyCallAssigneeToCurrentUserRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/HappyCall/UpdateHappyCallAssigneeToCurrentUser`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetPendingHappyCalls
     * @request POST:/HappyCall/GetPendingHappyCalls
     */
    happyCallGetPendingHappyCalls: (body: GetPendingHappyCallsPaginationRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetChangeRequestHappyCallResponse, any>({
        path: `/HappyCall/GetPendingHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCall
     * @name HappyCallGetHappyCallResultOptions
     * @request POST:/HappyCall/GetHappyCallResultOptions
     */
    happyCallGetHappyCallResultOptions: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/GetHappyCallResultOptions`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name HappyCallProcessAwaitingReviewSubmitAwaitingReviewHappyCalls
     * @request POST:/HappyCall/Process/AwaitingReview/SubmitAwaitingReviewHappyCalls
     */
    happyCallProcessAwaitingReviewSubmitAwaitingReviewHappyCalls: (
      body: SubmitAwaitingReviewHappyCallRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/HappyCall/Process/AwaitingReview/SubmitAwaitingReviewHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name HappyCallProcessAwaitingReviewGetAwaitingReviewHappyCalls
     * @request POST:/HappyCall/Process/AwaitingReview/GetAwaitingReviewHappyCalls
     */
    happyCallProcessAwaitingReviewGetAwaitingReviewHappyCalls: (
      body: GetAwaitingReviewHappyCallsRequest,
      params: RequestParams = {}
    ) =>
      this.request<PaginationResponseGetAwaitingReviewHappyCallsResponse, any>({
        path: `/HappyCall/Process/AwaitingReview/GetAwaitingReviewHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessAwaitingReview
     * @name HappyCallProcessAwaitingReviewGetOtherCustomerAwaitingReviewHappyCalls
     * @request POST:/HappyCall/Process/AwaitingReview/GetOtherCustomerAwaitingReviewHappyCalls
     */
    happyCallProcessAwaitingReviewGetOtherCustomerAwaitingReviewHappyCalls: (
      body: GetOtherCustomerAwaitingReviewHappyCallsRequest,
      params: RequestParams = {}
    ) =>
      this.request<GetAwaitingReviewHappyCallsResponse[], any>({
        path: `/HappyCall/Process/AwaitingReview/GetOtherCustomerAwaitingReviewHappyCalls`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetHappyCallInvoicesByCustomerId
     * @request POST:/HappyCall/Process/Invoice/GetHappyCallInvoicesByCustomerId
     */
    happyCallProcessInvoiceGetHappyCallInvoicesByCustomerId: (
      body: GetHappyCallInvoicesByCustomerIdRequest,
      params: RequestParams = {}
    ) =>
      this.request<IdNameResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetHappyCallInvoicesByCustomerId`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetInvoiceResultTypes
     * @request POST:/HappyCall/Process/Invoice/GetInvoiceResultTypes
     */
    happyCallProcessInvoiceGetInvoiceResultTypes: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetInvoiceResultTypes`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetInvoiceHappyCallResultOptions
     * @request POST:/HappyCall/Process/Invoice/GetInvoiceHappyCallResultOptions
     */
    happyCallProcessInvoiceGetInvoiceHappyCallResultOptions: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetInvoiceHappyCallResultOptions`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetDistinctOnTeams
     * @request POST:/HappyCall/Process/Invoice/GetDistinctOnTeams
     */
    happyCallProcessInvoiceGetDistinctOnTeams: (body: GetHappyCallInvoiceIdsRequest, params: RequestParams = {}) =>
      this.request<GetDistinctOnTeamsResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnTeams`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetDistinctOnPerson
     * @request POST:/HappyCall/Process/Invoice/GetDistinctOnPerson
     */
    happyCallProcessInvoiceGetDistinctOnPerson: (body: GetHappyCallInvoiceIdsRequest, params: RequestParams = {}) =>
      this.request<GetDistinctOnUserResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnPerson`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetDistinctOnProduct
     * @request POST:/HappyCall/Process/Invoice/GetDistinctOnProduct
     */
    happyCallProcessInvoiceGetDistinctOnProduct: (body: GetHappyCallInvoiceIdsRequest, params: RequestParams = {}) =>
      this.request<GetDistinctOnProductResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctOnProduct`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetDistinctItems
     * @request POST:/HappyCall/Process/Invoice/GetDistinctItems
     */
    happyCallProcessInvoiceGetDistinctItems: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetDistinctItems`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceGetCombinatoryDissatisfactionOptions
     * @request POST:/HappyCall/Process/Invoice/GetCombinatoryDissatisfactionOptions
     */
    happyCallProcessInvoiceGetCombinatoryDissatisfactionOptions: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/HappyCall/Process/Invoice/GetCombinatoryDissatisfactionOptions`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessInvoice
     * @name HappyCallProcessInvoiceSubmitInvoiceHappyCall
     * @request POST:/HappyCall/Process/Invoice/SubmitInvoiceHappyCall
     */
    happyCallProcessInvoiceSubmitInvoiceHappyCall: (dto: SubmitInvoiceHappyCallRequest, params: RequestParams = {}) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Invoice/SubmitInvoiceHappyCall`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name HappyCallProcessOpportunityGetHappyCallOpportunitiesByCustomerId
     * @request POST:/HappyCall/Process/Opportunity/GetHappyCallOpportunitiesByCustomerId
     */
    happyCallProcessOpportunityGetHappyCallOpportunitiesByCustomerId: (
      body: GetHappyCallOpportunitiesByCustomerIdRequest,
      params: RequestParams = {}
    ) =>
      this.request<IdNameResponse[], any>({
        path: `/HappyCall/Process/Opportunity/GetHappyCallOpportunitiesByCustomerId`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name HappyCallProcessOpportunityGetHappyOpportunityResultTypes
     * @request POST:/HappyCall/Process/Opportunity/GetHappyOpportunityResultTypes
     */
    happyCallProcessOpportunityGetHappyOpportunityResultTypes: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Opportunity/GetHappyOpportunityResultTypes`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessOpportunity
     * @name HappyCallProcessOpportunitySubmitOpportunityHappyCall
     * @request POST:/HappyCall/Process/Opportunity/SubmitOpportunityHappyCall
     */
    happyCallProcessOpportunitySubmitOpportunityHappyCall: (
      dto: SubmitOpportunityHappyCallRequest,
      params: RequestParams = {}
    ) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Opportunity/SubmitOpportunityHappyCall`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name HappyCallProcessPurchaseGetHappyCallPurchasesByCustomerId
     * @request POST:/HappyCall/Process/Purchase/GetHappyCallPurchasesByCustomerId
     */
    happyCallProcessPurchaseGetHappyCallPurchasesByCustomerId: (
      body: GetHappyCallPurchasesByCustomerIdRequest,
      params: RequestParams = {}
    ) =>
      this.request<PurchaseHappyCallResponse[], any>({
        path: `/HappyCall/Process/Purchase/GetHappyCallPurchasesByCustomerId`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name HappyCallProcessPurchaseGetPurchaseResultTypes
     * @request POST:/HappyCall/Process/Purchase/GetPurchaseResultTypes
     */
    happyCallProcessPurchaseGetPurchaseResultTypes: (params: RequestParams = {}) =>
      this.request<GetHappyCallTypesResponse[], any>({
        path: `/HappyCall/Process/Purchase/GetPurchaseResultTypes`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallProcessPurchase
     * @name HappyCallProcessPurchaseSubmitPurchaseHappyCall
     * @request POST:/HappyCall/Process/Purchase/SubmitPurchaseHappyCall
     */
    happyCallProcessPurchaseSubmitPurchaseHappyCall: (
      dto: SubmitPurchaseHappyCallRequest,
      params: RequestParams = {}
    ) =>
      this.request<SubmitHappyCallResponse[], any>({
        path: `/HappyCall/Process/Purchase/SubmitPurchaseHappyCall`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  happyCallReport = {
    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportAllHappyCallCount
     * @request POST:/HappyCallReport/GetTotalHappyCallsCount
     */
    happyCallReportAllHappyCallCount: (dto: RangeDateRequest, params: RequestParams = {}) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetTotalHappyCallsCount`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportInvoiceHappyCallCount
     * @request POST:/HappyCallReport/GetInvoiceHappyCallsCount
     */
    happyCallReportInvoiceHappyCallCount: (dto: RangeDateRequest, params: RequestParams = {}) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetInvoiceHappyCallsCount`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportOpportunityHappyCallCount
     * @request POST:/HappyCallReport/GetOpportunityHappyCallCount
     */
    happyCallReportOpportunityHappyCallCount: (dto: RangeDateRequest, params: RequestParams = {}) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetOpportunityHappyCallCount`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportPurchaseHappyCallsCount
     * @request POST:/HappyCallReport/GetPurchaseHappyCallsCount
     */
    happyCallReportPurchaseHappyCallsCount: (dto: RangeDateRequest, params: RequestParams = {}) =>
      this.request<HappyCallReportResponse, any>({
        path: `/HappyCallReport/GetPurchaseHappyCallsCount`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportGetSubmittedHappyCalls
     * @request POST:/HappyCallReport/GetSubmittedHappyCalls
     */
    happyCallReportGetSubmittedHappyCalls: (
      request: PaginationRequestWithRangeDateAndSearch,
      params: RequestParams = {}
    ) =>
      this.request<PaginationResponseHappyCallListResponse, any>({
        path: `/HappyCallReport/GetSubmittedHappyCalls`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportGetOpportunityHappyCallStatistics
     * @request POST:/HappyCallReport/GetOpportunityHappyCallStatistics
     */
    happyCallReportGetOpportunityHappyCallStatistics: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<OpportunityHappyCallReportResponse, any>({
        path: `/HappyCallReport/GetOpportunityHappyCallStatistics`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HappyCallReport
     * @name HappyCallReportGetInvoicesHappyCallStatistics
     * @request POST:/HappyCallReport/GetInvoicesHappyCallStatistics
     */
    happyCallReportGetInvoicesHappyCallStatistics: (body: RangeDateRequest, params: RequestParams = {}) =>
      this.request<InvoicesHappyCallStatisticResponse, any>({
        path: `/HappyCallReport/GetInvoicesHappyCallStatistics`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  lead = {
    /**
     * No description
     *
     * @tags Lead
     * @name LeadUpdateLeadNameById
     * @request POST:/Lead/UpdateLeadNameById
     */
    leadUpdateLeadNameById: (requestBody: EditLeadNameRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Lead/UpdateLeadNameById`,
        method: 'POST',
        body: requestBody,
        type: ContentType.Json,
        ...params,
      }),
  }
  metadata = {
    /**
     * No description
     *
     * @tags Metadata
     * @name MetadataGetLeadSources
     * @request POST:/Metadata/GetLeadSources
     */
    metadataGetLeadSources: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/Metadata/GetLeadSources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name MetadataGetPhoneCallTypes
     * @request POST:/Metadata/GetPhoneCallTypes
     */
    metadataGetPhoneCallTypes: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/Metadata/GetPhoneCallTypes`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Metadata
     * @name MetadataGetLeadPreNames
     * @request POST:/Metadata/GetLeadPreNames
     */
    metadataGetLeadPreNames: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/Metadata/GetLeadPreNames`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  }
  onlineQuote = {
    /**
     * No description
     *
     * @tags OnlineQuote
     * @name OnlineQuoteGetOnlineQuotes
     * @request POST:/OnlineQuote/GetOnlineQuotes
     */
    onlineQuoteGetOnlineQuotes: (dto: GetOnlineQuotesRequest, params: RequestParams = {}) =>
      this.request<PaginationResponseGetOnlineQuotesResponse, any>({
        path: `/OnlineQuote/GetOnlineQuotes`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineQuote
     * @name OnlineQuoteGetOnlineQuoteStatuses
     * @request POST:/OnlineQuote/GetOnlineQuoteStatuses
     */
    onlineQuoteGetOnlineQuoteStatuses: (params: RequestParams = {}) =>
      this.request<OptionSetResponse[], any>({
        path: `/OnlineQuote/GetOnlineQuoteStatuses`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineQuote
     * @name OnlineQuoteUpdateStatus
     * @request POST:/OnlineQuote/UpdateStatus
     */
    onlineQuoteUpdateStatus: (dto: UpdateOnlineQuoteStatusRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/OnlineQuote/UpdateStatus`,
        method: 'POST',
        body: dto,
        type: ContentType.Json,
        ...params,
      }),
  }
  phoneBook = {
    /**
     * No description
     *
     * @tags PhoneBook
     * @name PhoneBookGetCallerInfo
     * @request POST:/PhoneBook/GetCallerInfo
     */
    phoneBookGetCallerInfo: (
      query: {
        phoneNumber: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetCallerInfoResponse, any>({
        path: `/PhoneBook/GetCallerInfo`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  phoneCall = {
    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallCreatePhoneCall
     * @request POST:/PhoneCall/Create
     */
    phoneCallCreatePhoneCall: (data: CreatePhoneCallRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/PhoneCall/Create`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallCreateAttendedTransferPhoneCall
     * @request POST:/PhoneCall/CreateAttended
     */
    phoneCallCreateAttendedTransferPhoneCall: (
      data: CreateAttendedTransferPhoneCallRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/PhoneCall/CreateAttended`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallUpdatePhoneCallOnPickup
     * @request POST:/PhoneCall/Update-Pickup
     */
    phoneCallUpdatePhoneCallOnPickup: (data: UpdatePhoneCallOnPickup, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/PhoneCall/Update-Pickup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallUpdatePhoneCallOnVarSet
     * @request POST:/PhoneCall/Update-VarSet
     */
    phoneCallUpdatePhoneCallOnVarSet: (data: UpdatePhoneCallOnVarSet, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/PhoneCall/Update-VarSet`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallUpdatePhoneCallEndDate
     * @request POST:/PhoneCall/Update-EndDate
     */
    phoneCallUpdatePhoneCallEndDate: (data: UpdatePhoneCallDateRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/PhoneCall/Update-EndDate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallCreateRing
     * @request POST:/PhoneCall/CreateRing
     */
    phoneCallCreateRing: (data: CreateRingRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/PhoneCall/CreateRing`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallUpdateRing
     * @request POST:/PhoneCall/UpdateRing
     */
    phoneCallUpdateRing: (data: UpdateRingRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/PhoneCall/UpdateRing`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PhoneCall
     * @name PhoneCallSetRingDuration
     * @request POST:/PhoneCall/SetRingDuration
     */
    phoneCallSetRingDuration: (
      query: {
        id: string
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/PhoneCall/SetRingDuration`,
        method: 'POST',
        query: query,
        ...params,
      }),
  }
  product = {
    /**
     * No description
     *
     * @tags Product
     * @name ProductGetProductsByProductType
     * @request POST:/Product/GetProductsByProductType
     */
    productGetProductsByProductType: (body: GetProductsByProductTypeRequest, params: RequestParams = {}) =>
      this.request<GetProductsByProductTypeResponse[], any>({
        path: `/Product/GetProductsByProductType`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  productType = {
    /**
     * No description
     *
     * @tags ProductType
     * @name ProductTypeGetProductTypes
     * @request POST:/ProductType/GetProductTypes
     */
    productTypeGetProductTypes: (params: RequestParams = {}) =>
      this.request<GetProductTypesResponse[], any>({
        path: `/ProductType/GetProductTypes`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProductType
     * @name ProductTypeGetCurrentUserProductTypes
     * @request POST:/ProductType/GetCurrentUserProductTypes
     */
    productTypeGetCurrentUserProductTypes: (
      query: {
        search: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetCurrentUserProductTypesResponse[], any>({
        path: `/ProductType/GetCurrentUserProductTypes`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  salesPersonForm = {
    /**
     * No description
     *
     * @tags SalesPersonForm
     * @name SalesPersonFormSubmitPriceInquiry
     * @request POST:/SalesPersonForm/SubmitPriceInquiry
     */
    salesPersonFormSubmitPriceInquiry: (body: SubmitPriceInquiryRequest, params: RequestParams = {}) =>
      this.request<SubmitPriceInquiryResponse, any>({
        path: `/SalesPersonForm/SubmitPriceInquiry`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersonForm
     * @name SalesPersonFormSubmitSalesPersonTransfer
     * @request POST:/SalesPersonForm/SubmitSalesPersonTransfer
     */
    salesPersonFormSubmitSalesPersonTransfer: (body: SubmitSalesPersonTransferRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/SalesPersonForm/SubmitSalesPersonTransfer`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersonForm
     * @name SalesPersonFormSubmitSalesPersonOthers
     * @request POST:/SalesPersonForm/SubmitSalesPersonOthers
     */
    salesPersonFormSubmitSalesPersonOthers: (body: SubmitSalesPersonOthersRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/SalesPersonForm/SubmitSalesPersonOthers`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SalesPersonForm
     * @name SalesPersonFormSubmitSalesPersonFollowUp
     * @request POST:/SalesPersonForm/SubmitSalesPersonFollowUp
     */
    salesPersonFormSubmitSalesPersonFollowUp: (body: SubmitSalesPersonFollowUpRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/SalesPersonForm/SubmitSalesPersonFollowUp`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  }
  systemUser = {
    /**
     * No description
     *
     * @tags SystemUser
     * @name SystemUserGetSystemUsers
     * @request POST:/SystemUser/GetSystemUsers
     */
    systemUserGetSystemUsers: (params: RequestParams = {}) =>
      this.request<GetSystemUsersResponse[], any>({
        path: `/SystemUser/GetSystemUsers`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemUser
     * @name SystemUserFindByUsername
     * @request POST:/SystemUser/FindByUsername
     */
    systemUserFindByUsername: (
      query: {
        username: string
      },
      params: RequestParams = {}
    ) =>
      this.request<GetSystemUsersResponse, any>({
        path: `/SystemUser/FindByUsername`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemUser
     * @name SystemUserGetUsersInfo
     * @request POST:/SystemUser/GetUsersInfo
     */
    systemUserGetUsersInfo: (params: RequestParams = {}) =>
      this.request<GetUsersInfoResponse[], any>({
        path: `/SystemUser/GetUsersInfo`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemUser
     * @name SystemUserGetUserTransferRate
     * @request POST:/SystemUser/GetUserTransferRate
     */
    systemUserGetUserTransferRate: (params: RequestParams = {}) =>
      this.request<SystemUserTransferRate[], any>({
        path: `/SystemUser/GetUserTransferRate`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SystemUser
     * @name SystemUserFindLastSystemUserTalkedToCustomer
     * @request POST:/SystemUser/FindLastSystemUserTalkedToCustomer
     */
    systemUserFindLastSystemUserTalkedToCustomer: (
      query: {
        phoneNumber: string
      },
      params: RequestParams = {}
    ) =>
      this.request<FindLastSystemUserTalkedToCustomerResponse, any>({
        path: `/SystemUser/FindLastSystemUserTalkedToCustomer`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  }
  teams = {
    /**
     * No description
     *
     * @tags Team
     * @name TeamGetCallCenterTeams
     * @request POST:/Teams/GetCallCenterTeams
     */
    teamGetCallCenterTeams: (params: RequestParams = {}) =>
      this.request<GetTeamsResponse[], any>({
        path: `/Teams/GetCallCenterTeams`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  }
  test = {
    /**
     * No description
     *
     * @tags Test
     * @name TestRelateRings
     * @request GET:/Test/RelateRings
     */
    testRelateRings: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Test/RelateRings`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TestRelatePhoneCallsParent
     * @request GET:/Test/RelatePhoneCallsParent
     */
    testRelatePhoneCallsParent: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/Test/RelatePhoneCallsParent`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Test
     * @name TestTest
     * @request GET:/Test/Test
     */
    testTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/Test/Test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
  api = {
    /**
     * No description
     *
     * @tags Test
     * @name TestGetNullParentRings
     * @request GET:/api/Test
     */
    testGetNullParentRings: (params: RequestParams = {}) =>
      this.request<BaseRingsModel[], any>({
        path: `/api/Test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  }
}
